import AlvaLogo from "../../../assets/alva/img/alva-logo.svg";
import LogoWhite from "../../../assets/default/img/logo_white.png";
import WavelrLogo from "../../../assets/wavelr/img/wavelr-logo.svg";
import { SiteName } from "../../../utils/enums";

export function getPublicLayoutLogo(siteName: SiteName) {
  if (siteName === SiteName.Alva) {
    return AlvaLogo;
  } else {
    if (siteName === SiteName.Wavelr) {
      return WavelrLogo;
    } else {
      return LogoWhite;
    }
  }
}
